import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError, share } from 'rxjs/operators';
import { LoadingService } from '@schoolbelle/common/loading';
import { StaffAuthService } from '../../shared/services';

@Injectable({
  providedIn: 'root',
})
export class MainGuard implements CanActivate {
  constructor(
    private auth: StaffAuthService,
    private loading: LoadingService,
    private router: Router,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const ob = this.auth.fetchUser().pipe(
      map((decoded) => {
        if (!decoded) throw new Error('Not logged in.');
        return true;
      }),
      catchError((e) => {
        console.error(e);
        this.router.navigate(['/login'], {
          queryParams: {
            redirect_uri: state.url,
          },
        });
        return of(false);
      }),
      share(),
    );
    this.loading.open({
      message: 'Fetching user info......',
      busy: ob.subscribe(),
    });
    return ob;
  }
}
